<script setup lang="ts">
type Props = {
  align?: 'left' | 'right'
};

const props = withDefaults(defineProps<Props>(), {
  align: 'right',
});
</script>
<template>
  <div class="flex items-center gap-2" :class="{'justify-end': props.align === 'right'}">
    <slot />
  </div>
</template>
